import { h, Fragment } from 'preact'; /** @jsx h */
import { useState, useEffect } from 'preact/hooks';
import { strddmmyyyyhhMM, localeTime } from '../global/dateVariables';
import {
    LinkBtnStyled,
    SecondaryBtn,
    BtnPersonModal
} from '../global/generalComponentsButtons';
import { useSelector } from 'react-redux';

const BtnNewShift = ({ rowInfo, shift }) => {
    const getBaseHref = () => {
        let retstring = '/dashboard/';
        if (rowInfo && rowInfo.baseid) {
            //is base view
            if (rowInfo.baseid == 65 || rowInfo.baseid == 66)
                retstring += 'nytt-kurs';
            else if ([55, 62, 63, 69].includes(rowInfo.baseid))
                retstring += 'ny-f';
            else retstring += 'ny-vakt';

            retstring += `?base=${rowInfo.baseid || ''}`;
        } else if (rowInfo && rowInfo.usid)
            retstring += `ny-vakt?usid=${rowInfo.usid || ''}`;
        if (shift && rowInfo)
            retstring += `&startday=${localeTime(shift.start) || ''}&crew=${
                rowInfo.crewType || ''
            }`;
        return retstring;
    };
    const getLabel = () => {
        if (rowInfo?.baseid == 65 || rowInfo?.baseid == 73)
            return '+ Legg til kurs';
        else if (rowInfo?.baseid == 66) return '+ Legg til kursus';
        else if (rowInfo?.baseid == 55 || rowInfo?.baseid == 69)
            return '+ Legg til Ferie';
        else if (rowInfo?.baseid == 62 || rowInfo?.baseid == 63)
            return '+ Legg til Fravær';

        return '+ Legg til vakt';
    };
    return (
        <LinkBtnStyled
            label={getLabel()}
            href={getBaseHref()}
            className="submit-btn btn-hover"
        />
    );
};

export const HoverInfo = ({
    shift,
    rowInfo,
    classInfo,
    isVisible,
    ignoreGoTo,
    hideFunction,
    setModalShow
}) => {
    const toggleShowPersonModal = () => {
        setModalShow(shift.usid, true);
    };
    const options = useSelector((state) => state.options);
    const [rolle, setRolle] = useState('');

    useEffect(() => {
        if (shift && options?.roller) {
            if ([6, 7, 30].includes(shift.baseid)) {
                let rolleObj = options.roller.find(
                    (e) =>
                        parseInt(e.roleId) == shift.rolle &&
                        e.crewCode == shift.crewkd
                );
                setRolle(rolleObj.roleName);
            }
        }
    }, [options, shift]);

    return (
        <div
            className={`hover-info  ${shift ? 'tall-box' : 'box-short'}${
                isVisible ? ' display-hover' : ''
            }${ignoreGoTo ? ' fixed-box' : ''}`}
        >
            {shift && (
                <Fragment>
                    <p>
                        Base: {shift.base}{' '}
                        {rowInfo.crewType === 10 ? 'HCM' : 'Pilot'}
                    </p>
                    <div>
                        {shift.navn && ignoreGoTo !== true && (
                            <BtnPersonModal
                                label={`På vakt: ${shift.navn} ${
                                    rolle != '' ? `(${rolle})` : ''
                                }`}
                                onClick={toggleShowPersonModal}
                            />
                        )}
                        {shift.navn && ignoreGoTo && (
                            <p>
                                På vakt: {shift.navn}{' '}
                                {rolle != '' ? `(${rolle})` : ''}
                            </p>
                        )}
                        <p>Start: {strddmmyyyyhhMM(shift.start, true)}</p>
                        {shift.end && (
                            <p>Slutt: {strddmmyyyyhhMM(shift.end, true)}</p>
                        )}
                        {shift.antDager && (
                            <p>
                                antall (hele) dager:{' '}
                                {Math.round(shift.antDager)}
                            </p>
                        )}
                        {!ignoreGoTo &&
                            shift.tekst != '' &&
                            shift.tekst != undefined && (
                                <p>Logg melding: {shift.tekst}</p>
                            )}
                        {shift.kommentar != '' &&
                            shift.kommentar != undefined && (
                                <p>Kommentar: {shift.kommentar}</p>
                            )}
                    </div>
                    {ignoreGoTo !== true && !shift.isEmpty && (
                        <LinkBtnStyled
                            label="Gå til vakt"
                            href={`/${
                                window.location.pathname.split('/')[1]
                            }/vaktuke/${shift.base}/${
                                shift.crewkd === 10 ? 'HCM' : 'Pilot'
                            }/${shift.ukenr}/${shift.id}`}
                            className="btn-secondary btn-hover"
                        />
                    )}
                </Fragment>
            )}
            {classInfo && classInfo !== 'isOK' && (
                <p>
                    {classInfo === 'dobbelperson' && (
                        <span>Person dobbeltbooket i tidsrom</span>
                    )}
                    {classInfo === 'dobbelvakt' && (
                        <span>Flere personer på samme vakt</span>
                    )}
                    {classInfo === 'isempty' && <span>Ingen på vakt</span>}
                </p>
            )}
            {rowInfo && ignoreGoTo !== true && shift.isEmpty && (
                <BtnNewShift rowInfo={rowInfo} shift={shift} />
            )}
            {ignoreGoTo && (
                <SecondaryBtn
                    label="Lukk"
                    type="button"
                    onClick={hideFunction}
                    className="submit-btn btn-hover"
                />
            )}
        </div>
    );
};

export const Td = (props) => {
    const {
        rows,
        row,
        dobbelpersonSchvid,
        dobbelvaktSchvid,
        showExtraInfo,
        setShowExtra,
        ignoreGoTo,
        setModalShow,
        classNames,
        maxShow,
        yAxisView,
        shiftweek
    } = props;

    const [hoverInfo, setHoverInfo] = useState({});

    const changeShowExtra = (setId, shift, clName) => {
        if (showExtraInfo.id === setId)
            setShowExtra({ ...showExtraInfo, show: !showExtraInfo.show });
        else if (showExtraInfo.show === true && showExtraInfo.id !== setId)
            setShowExtra({ ...showExtraInfo, id: setId });
        else setShowExtra({ show: !showExtraInfo.show, id: setId });

        setHoverInfo({ id: setId, shift: shift, clName: clName });
    };

    const hideHover = () => {
        setShowExtra({ ...showExtraInfo, show: false });
        setHoverInfo({});
    };

    return (
        <td
            className={classNames}
            colspan={maxShow}
            style={`${shiftweek ? 'background-color:white !important' : ''}`}
        >
            {rows[row].shifts.length > 0 && (
                <Fragment>
                    {hoverInfo && Object.keys(hoverInfo).length > 0 && (
                        <HoverInfo
                            shift={hoverInfo.shift}
                            row={row}
                            rowInfo={rows[row]}
                            classInfo={hoverInfo.clName}
                            isVisible={
                                showExtraInfo.show &&
                                showExtraInfo.id === hoverInfo.id
                            }
                            ignoreGoTo={ignoreGoTo}
                            hideFunction={hideHover}
                            setModalShow={setModalShow}
                        />
                    )}
                    <div className="vakt-oversikt">
                        {rows[row].shifts.map((shift) => {
                            let lightFont = true;
                            let loggMelding = false;
                            if (shift.tekst != '' && shift.tekst != undefined)
                                loggMelding = true;
                            if (shift.color) {
                                if (
                                    [
                                        '#F5EE6A',
                                        '#2CB195',
                                        '#F5842B',
                                        '#6693BB',
                                        '#A4A29F',
                                        '#98FF1E',
                                        '#FFD7B5'
                                    ].includes(shift.color.toUpperCase())
                                ) {
                                    lightFont = false;
                                }
                            }
                            let clName = 'isOK';
                            if (shift.usid == 0) clName = 'isempty';
                            else if (
                                dobbelpersonSchvid &&
                                dobbelpersonSchvid.includes(shift.id)
                            )
                                clName = 'dobbelperson';
                            else if (
                                dobbelvaktSchvid &&
                                dobbelvaktSchvid.includes(shift.id)
                            )
                                clName = 'dobbelvakt';

                            let name = '';
                            if (maxShow > 50 && yAxisView == 'base') {
                                if (
                                    shift.usid == 0 &&
                                    shift.isEmpty == undefined
                                )
                                    name = 'L';
                                else name = shift.knavn2;
                            } else {
                                name = shift.vaktLabel;
                            }
                            // ${!ignoreGoTo && loggMelding ? `background-image: linear-gradient(to right, rgba(184,122,250,0.6082633737088585) 5%, ${shift.color} 95%);` : ''}
                            return (
                                <Fragment>
                                    <div
                                        style={`grid-column-start:${
                                            shift.startColumn || 1
                                        };grid-column-end:${
                                            shift.endColumn || 2
                                        };background-color:${shift.color};`}
                                        className={`vakt-detail${
                                            lightFont ? '' : ' dark-font'
                                        }${
                                            showExtraInfo.id == shift.id &&
                                            showExtraInfo.show
                                                ? ' hoverinfo-showing'
                                                : ''
                                        }${
                                            shift.isEmpty
                                                ? ' set-new-shift'
                                                : ''
                                        }`}
                                        onClick={(_) =>
                                            changeShowExtra(
                                                shift.id,
                                                shift,
                                                clName
                                            )
                                        }
                                    >
                                        <p>
                                            {name || ''}
                                            {!ignoreGoTo && loggMelding ? (
                                                <sup
                                                    style={
                                                        'font-size: 70% !important;'
                                                    }
                                                >
                                                    N
                                                </sup>
                                            ) : (
                                                ''
                                            )}
                                        </p>
                                    </div>
                                </Fragment>
                            );
                        })}
                    </div>
                </Fragment>
            )}
        </td>
    );
};
